export default function Offers() {
  const offers = [
    { 
      title: "📦 Warehousing Solutions", 
      desc: "Modern, secure facilities with advanced Warehouse Management Systems (WMS). Flexible options: contract logistics, on-demand storage, and fulfillment centers. Value-added services: packaging, labeling, kitting, and reverse logistics." 
    },
    { 
      title: "✈️ Air Cargo Services", 
      desc: "Fast, reliable domestic and international freight. Express delivery for time-sensitive shipments. Specialized cold chain logistics for pharmaceuticals and perishables." 
    },
    { 
      title: "🚢 Sea Cargo Services", 
      desc: "Full Container Load (FCL) and Less than Container Load (LCL). Bulk and breakbulk shipping for oversized or heavy cargo. Integrated port-to-door solutions via Mumbai's Nhava Sheva and global ports." 
    },
    { 
      title: "📑 Customs Clearance", 
      desc: "End-to-end documentation and compliance support. HS code classification and duty assessment. Bonded warehousing and inspection coordination." 
    },
    { 
      title: "🛡️ Insurance Solutions", 
      desc: "Marine, air, road, and rail cargo coverage. All-risk and named perils policies tailored to shipment type. Door-to-door protection with claims management support." 
    },
    { 
      title: "🚚 Logistics & Distribution", 
      desc: "Multimodal transport: road, rail, air, and sea. Nationwide last-mile delivery and international distribution. Technology-driven tracking and route optimization." 
    }
  ];

  const benefits = [
    { title: "Efficiency", desc: "Streamlined processes reduce costs and delays" },
    { title: "Reliability", desc: "Goods delivered safely and on time" },
    { title: "Scalability", desc: "Flexible solutions for seasonal or growing demand" },
    { title: "Global Reach", desc: "Access to international markets with compliance expertise" },
    { title: "Risk Mitigation", desc: "Insurance and customs support safeguard continuity" },
    { title: "Customer Focus", desc: "Responsive service with dedicated support for every shipment" }
  ];

  return (
    <section id="offers" className="offers">
      <h2 className="section-title">What We Offer</h2>
      <p>At AROCL Customs Solutions, we provide end-to-end logistics and cargo services designed to make supply chains seamless, secure, and culturally authentic. Our offerings combine technical rigor with trust-building design, ensuring every client feels confident in their operations.</p>
      
      <div className="service-list">
        {offers.map((offer, i) => (
          <div key={i} className="service-card">
            <h3>{offer.title}</h3>
            <p>{offer.desc}</p>
          </div>
        ))}
      </div>

      <h3 className="benefits-title">🌍 Why Choose Us</h3>
      <div className="why-choose-us-container">
        <div className="why-choose-us-background">
          <div className="why-choose-us-content">
            <div className="benefits-grid">
              {benefits.map((benefit, i) => (
                <div key={i} className="benefit-card">
                  <div className="benefit-icon">
                    {i === 0 ? '⚡' : i === 1 ? '🛡️' : i === 2 ? '📈' : i === 3 ? '🌐' : i === 4 ? '🎯' : '🤝'}
                  </div>
                  <div className="benefit-title">{benefit.title}</div>
                  <div className="benefit-text">{benefit.desc}</div>
                </div>
              ))}
            </div>
            <div className="why-choose-us-stats">
              <div className="stat-item">
                <div className="stat-number">500+</div>
                <div className="stat-label">Happy Clients</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">10K+</div>
                <div className="stat-label">Shipments Handled</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">99.8%</div>
                <div className="stat-label">On-Time Delivery</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
